import { render, staticRenderFns } from "./MasterActivityFpkkDetail.vue?vue&type=template&id=5d34f1ac&scoped=true"
import script from "./MasterActivityFpkkDetail.vue?vue&type=script&lang=js"
export * from "./MasterActivityFpkkDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d34f1ac",
  null
  
)

export default component.exports